import {TypeMarcheReserve} from './TypeMarcheReserve';
export class Oui_TypeOuiNonReservationMarche {

	public reservationMarche: TypeMarcheReserve;

	constructor() { 
		 		this.reservationMarche = new TypeMarcheReserve();
 
	}
}
